import * as React from "react";
type Props = {
  className?: string,
};
function SvgPepper({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-pepper"
      className={className}
    >
      <mask
        id="mask0_21_1560"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={24}
        height={24}
      >
        <path d="M24 0H0V24H24V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_21_1560)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13 2C15.2572 2 16.679 3.87429 16.6277 6.08903C19.4141 6.55069 21 8.76759 21 12C21 17.421 16.7481 22 10 22C9.51917 22 9.00938 21.9592 8.49281 21.8801L8.04889 21.8031C5.52977 21.3146 3 19.944 3 18C3 16.7532 3.73213 16.314 5.31302 15.9187L5.86309 15.7832L6.36792 15.6491L6.68377 15.5513C8.26534 15.0241 9 14.1262 9 12L9.00423 11.7688C9.11756 8.67962 11.498 6.40597 14.6299 6.04901C14.6663 4.92108 14.058 4.07728 13.1304 4.00503L13 4V2ZM15 12C13.4114 12 12.0714 12.2224 10.9764 12.6579C10.7956 15.2785 9.49595 16.7221 7.31623 17.4487C7.06524 17.5323 6.80767 17.6062 6.50599 17.6838L5.49058 17.9398L5.25455 18.0109C5.18673 18.0333 5.12924 18.0545 5.0805 18.0751L5.017 18.103L5.03504 18.1588C5.36881 18.9422 8.01366 19.9315 9.81662 19.9966L10 20C15.3316 20 18.659 16.7006 18.9752 12.6399C17.8893 12.216 16.5654 12 15 12ZM15.5 8C13.5426 8 11.9671 8.96408 11.3192 10.442C12.4139 10.1458 13.6412 10 15 10C16.422 10 17.7001 10.1597 18.8324 10.4835C18.4316 8.85817 17.306 8 15.5 8Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
export default SvgPepper;
